import React from 'react';
import Footer from '../Shared/Footer/Footer';
import Navbar from '../Shared/Navbar/Navbar';
import moon from '../../images/moonp.webp';
import Fade from 'react-reveal/Fade';

const About = () => {
    return (
        <div className="header-container">
            <Navbar></Navbar>
            <div className="container my-3">
            <div className="row g-0">
            <Fade left>
            <div className="col-md-7 m-md-0 p-3 border border-top-0 border-bottom-0 border-start-0 border-warning border-3">
                <img className="img-fluid w-50 ms-5 mb-2" src={moon} alt="moon" />
                    <h5 className="text-warning">Hello</h5>
                    <h3 className="text-white">I am <span className="text-warning">Moon Saha Chowdhury </span></h3>
                    <p className="text-white text-sm-start p-2 me-3">An enthusiastic and self-motivated web developer with some knowledge of frameworks for frontend and backend development. I have a desire to pursue a career with challenging targets so that I can use my qualification, leadership, creativity to provide the highest level of technical support.</p>

                </div>
            </Fade>
                <Fade right>
                <div className="col-md-5 p-2"> 
                <h4 className="text-warning ms-3">Expertise</h4>
                <ul className="list-inline ms-3 my-3">
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary text-wrap">React JS</li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary text-wrap">React Router</li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary text-wrap">React Bootstrap</li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary text-wrap">HTML5</li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary text-wrap">CSS3</li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary mt-2 text-wrap">Bootstrap5</li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary mt-2 text-wrap">JavaScript(ES6)</li>

                </ul>
                <h4 className="text-warning ms-3">Comfortable</h4>
                <ul className="list-inline ms-3 mt-3">
                <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary text-wrap">Node </li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary text-wrap">Express</li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary text-wrap">MongoDB</li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary text-wrap">MySQL</li>
                    <li className="list-inline-item p-3 fs-6 text-white badge bg-secondary mt-2 text-wrap">Java(basic)</li>

                </ul>
                <h4 className="text-warning ms-3 ">Tools and Software</h4>
                <ul className="list-inline ms-3 mt-3">
                <li className="list-inline-item p-2 fs-6 text-white badge bg-secondary text-wrap">Git </li>
                    <li className="list-inline-item p-2 fs-6 text-white badge bg-secondary text-wrap">VS Code</li>
                    <li className="list-inline-item p-2 fs-6 text-white badge bg-secondary text-wrap">Chrome Dev Tool</li>
                    <li className="list-inline-item p-2 fs-6 text-white badge bg-secondary text-wrap">Heroku</li>
                    <li className="list-inline-item p-2 fs-6 text-white badge bg-secondary text-wrap">Netlify</li>
                    <li className="list-inline-item p-2 fs-6 text-white badge bg-secondary mt-2 text-wrap">Firebase</li>


                </ul>


                </div>
                </Fade>
            </div>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default About;